module.exports = __webpack_public_path__ + "static/media/community-gardens-thumb-8.1cb45052.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/community-gardens/community-gardens-thumb-8.jpg
// module id = 4123
// module chunks = 14